export default {
  props: {
    routeName: {
      type: String,
      default() {
        return '#'
      },
    },
    buttonVariant: {
      type: String,
      default() {
        return 'primary'
      },
    },
    alertText: {
      type: String,
      default() {
        return this.$t('redirect_alert_text')
      },
    },
    isShow: {
      type: Boolean,
      default() {
        return false
      },
    },
    alertVariant: {
      type: String,
      default() {
        return 'primary'
      },
    },
    buttonText: {
      type: String,
      default() {
        return this.$t('countinue')
      },
    },
  },
}
